import {AppIconName} from "@shared/components/app-icon";

export type StructureMegamenu = {
  product_title_menu: string;
  img: { src: string, alt: string },
  product_title_left: {label: string, path: string},
  product_subtitle_left: string;
  product_title_right: string;
  product_title_right_optional?: string;
  labelGoToPage?: {label: string, path: string};
  label_redirect?: {label: string, path: string};
  faq_text?: {label: string, path: string, id ?:string};
  labelGoToPageOptional?: {label: string, path: string};
  card?: {
    title: string;
    description: string;
    find_outmore: {label: string, path: string},
    img_right: {src: string, alt: string}
  }

  icon: { appIconName: AppIconName, alt: string },
  menu_link_product_left: {
    url: string;
    label: string;
  }[],
  menu_link_product_right: {
    url: string;
    label: string;
  }[],
  menu_link_product_right_optional: {
    url: string;
    label: string;
  }[],
  activeArrow: boolean;
  link_see_all: string;
}
export type TypeProduct = 'Viaggi' | 'Casa' | 'Salute' | 'Mobilità';
const TIPOLOGIE  = [
    {
      url: '/prodotti-per-te/viaggi/viaggi-nostop-stage',
      label: 'Viaggi per Studio o Stage'
    },
    {
      url: '/prodotti-per-te/viaggi/viaggi-nostop-lavoro',
      label: 'Viaggi di Lavoro'
    },
    {
      url: '/prodotti-per-te/viaggi/annuale-multiviaggio-light',
      label: 'Viaggi frequenti in Europa'
    },
    {
      url: '/prodotti-per-te/viaggi/medico-nostop',
      label: `Per chi visita l'Italia dall'estero`
    },


  ]
export const STRUCTURELINKMEGAMENU: StructureMegamenu[] = [

    {
      product_title_menu: 'Viaggi',
      img: { src: '/assets/img/newImg/redion-viaggi.png', alt: 'Viaggi' },
      icon: { appIconName: 'AirplaneTakeoff', alt: 'plane' },
      product_title_left: {label: 'Polizze Viaggio', path: '/prodotti-per-te/viaggi'},
      product_subtitle_left: 'Proteggi il tuo viaggio da ogni imprevisto',
      activeArrow: false,
      menu_link_product_left: [
        {
          url: '/prodotti-per-te/viaggi/viaggi-nostop-vacanza',
          label: 'Assicurazione Sanitaria Viaggio'
        },
        {
          url: '/prodotti-per-te/viaggi/cancellation-top',
          label: 'Assicurazione Cancellazione Viaggio'
        },
        {
          url: '/prodotti-per-te/viaggi/viaggi-nostop-vacanza-multiviaggio',
          label: 'Assicurazione Annuale Multiviaggio'
        },
        {
          url: '/prodotti-per-te/viaggi/viaggi-nostop-usa-canada',
          label: 'Assicurazione Sanitaria Viaggio USA'
        }
      ],
      menu_link_product_right: TIPOLOGIE,
      menu_link_product_right_optional: [
        {
          url: '/prodotti-per-te/viaggi/viaggi-full-protection',
          label: 'Polizza Sanitaria con Annullamento'
        },
        {
          url: '/prodotti-per-te/viaggi/viaggi-nostop-gruppi',
          label: 'Viaggi per Gruppi numerosi'
        },
        {
          url: '/prodotti-per-te/viaggi/sci-noproblem',
          label: 'Vacanze sulla neve'
        },
        {
          url: '/prodotti-per-te/viaggi/viaggi-nostop-infortuni-in-volo',
          label: 'Infortuni in volo'
        }
      ],
      faq_text: {label: 'FAQ Viaggi', path: '/prodotti-per-te/viaggi', id: '1'},
      product_title_right: 'Tipologie di Viaggio',
      product_title_right_optional: 'Coperture Speciali',
      label_redirect: {label: 'I nostri consigli di viaggio', path: '/contenuti-utili/consigli-viaggio'},
      link_see_all: "/prodotti-per-te/viaggi",
     /*  labelGoToPage: {label: "Vedi tutti", path: '/prodotti-per-te/viaggi'}, */
      labelGoToPageOptional: {label: 'Viaggiare Sicuri', path: '/contenuti-utili/viaggiare-sicuri'}
    },
     {
      product_title_menu: 'Casa',
      img: { src: '/assets/img/newImg/redion-casa.png', alt: 'Casa' },
      icon: { appIconName: 'House', alt: 'house' },
      product_title_left: {label: 'Polizze Casa',  path: '/prodotti-per-te/casa'},
      product_subtitle_left: 'Proteggi la tua casa, la tua famiglia o i tuoi animali domestici. ',
      activeArrow: false,
      menu_link_product_left: [
        {
          url: '/prodotti-per-te/casa/miglior-amico',
          label: 'Assicurazione Cane e Gatto'
        },
        {
          url: '/prodotti-per-te/casa/sfera-casa-relax',
          label: 'Assicurazione Casa'
        },
        {
          url: '/prodotti-per-te/casa/sfera-casa-relax-green',
          label: 'Assicurazione Casa con Impianto Fotovoltaico'
        },
        {
          url: '/prodotti-per-te/casa/famiglia-3d',
          label: 'RC Famiglia'
        }
      ],
      menu_link_product_right: [
       /*  {
            url: '',
            label: 'Intervento fabbro'
        },
        {
            url: '',
            label: 'Intervento elettricista'
        },
        {
            url: '',
            label: 'Intervento tapparellista'
        } */
      ],
      menu_link_product_right_optional: [

      ],
      card: {
        title: 'Digitale Sicuro',
        description: 'La piattaforma completa per la protezione online dei tuoi dati personali e finanziari. Rende sicuri i tuoi dispositivi e la tua privacy grazie ad un monitoraggio costante di deep e dark web e ti avvisa immediatamente in caso di data breach. Grazie all’assistenza 24/7 hai sempre un team di esperti al tuo fianco per garantirti sicurezza e tranquillità.',
        find_outmore: {label: 'Scopri di più', path: '/prodotti-per-te/casa/digitale-sicuro'},
        img_right: {src: "/assets/img/newImg/digitale-sicuro.svg", alt: 'digitale sicuro'}
      },
      product_title_right: 'Servizi di assistenza',
      product_title_right_optional: '',
      faq_text: {label: 'FAQ Casa', path: '/prodotti-per-te/casa', id: '2'},
      link_see_all: "/prodotti-per-te/casa"
    },
     {
      product_title_menu: 'Salute',
      img: { src: '/assets/img/newImg/redion-salute.png', alt: 'Salute' },
      icon: { appIconName: 'Heartbeat', alt: 'house' },
      product_title_left: {label: 'Polizze Salute',  path: '/prodotti-per-te/salute'},
      product_subtitle_left: 'Le migliori soluzioni assicurative per la tua salute e quella dei tuoi cari',
      faq_text: {label: 'FAQ Salute', path: '/prodotti-per-te/salute', id: '3'},
      activeArrow: false,
      menu_link_product_left: [
        {
          url: '/prodotti-per-te/salute/eura-salute-360-malattia',
          label: 'Assicurazione Malattia'
        },
        {
          url: '/prodotti-per-te/salute/eura-salute-360-infortuni',
          label: 'Assicurazione Infortuni'
        },
        {
          url: '/prodotti-per-te/salute/eura-salute-360-interventi',
          label: 'Assicurazione Interventi'
        },
        {
          url: '/prodotti-per-te/salute/medico-nostop-resident',
          label: 'Assicurazione Medica per cittadini stranieri in Italia'
        }
      ],
      menu_link_product_right: [
      ],
      menu_link_product_right_optional: [],
      product_title_right: 'Servizi per la Salute',
      product_title_right_optional: '',
       card: {
        title: 'MyClinic',
        description: 'La piattaforma digitale per la cura della tua salute e di quella dei tuoi familiari. Ottieni subito un’analisi dei sintomi e organizza un video consulto h24 con i nostri medici. Tieni aggiornati i tuoi valori e condividili facilmente con un medico. Puoi anche chiedere il parere di uno specialista o organizzare visite ed esami a tariffe agevolate presso le nostre strutture convenzionate.',
        find_outmore: {label: 'Scopri di più', path: '/prodotti-per-te/salute/myclinic'},
        img_right: {src: "/assets/img/newImg/myclinic.svg", alt: 'My Clinic'}
      },
      link_see_all: "/prodotti-per-te/salute"

    },
     {
      product_title_menu: 'Mobilità',
      img: { src: '/assets/img/newImg/redion-mobilita.jpg', alt: 'Mobilità' },
      icon: { appIconName: 'Car', alt: 'car' },
      product_title_left: {label: 'Polizze Mobilità', path: '/prodotti-per-te/mobilita'},
      product_subtitle_left: `Le migliori soluzioni per l'assistenza stradale in Italia e all'estero`,
      activeArrow: false,
      menu_link_product_left: [
        {
          url: '/prodotti-per-te/mobilita/auto-noproblem',
          label: 'Assistenza Stradale Auto'
        },
        {
          url: '/prodotti-per-te/mobilita/moto-noproblem',
          label: 'Assistenza Stradale Moto'
        },
        {
          url: '/prodotti-per-te/mobilita/bike-noproblem-evolution',
          label: 'Assistenza Stradale Bici e e-Bike'
        },
        {
          url: '/prodotti-per-te/mobilita/mobilita-noproblem',
          label: 'Protezione per te e tutti i mezzi che guidi'
        }
      ],
      menu_link_product_right: [
        {
          url: 'https://sodauto.redion.it/',
          label: 'Soccorso stradale (da 99€)'
        },
        {
          url: '/prodotti-per-te/mobilita/noleggio-auto',
          label: 'Noleggio Auto'
        }
      ],
      menu_link_product_right_optional: [],
      product_title_right: 'Servizi di assistenza',
      product_title_right_optional: '',
      faq_text: {label: 'FAQ Mobilità', path: '/prodotti-per-te/mobilita', id: '4'},
       card: {
        title: 'Soccorso Stradale On Demand',
        description: 'Hai bisogno di assistenza stradale e non hai una polizza di assistenza? Ci pensa Redion! Richiedi l’intervento di un carroattrezzi, ad un prezzo già definito.',
        find_outmore: {label: 'Scopri di più', path: 'https://sodauto.redion.it/'},
        img_right: {src: "/assets/img/newImg/sod-auto.svg", alt: 'SOD'}
      },
      link_see_all: "/prodotti-per-te/mobilita"
    }




]
